
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/career/[category_id]/[position_id]",
      function () {
        return require("private-next-pages/career/[category_id]/[position_id].ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/career/[category_id]/[position_id]"])
      });
    }
  